const customHeroBanner = document.querySelector('.hero-banner-slider-with-animation--wrapper');
const customHeroBackground = document.querySelector('.hero-banner-slider-background');
const customSlider = customHeroBanner ? customHeroBanner.querySelector('carousel-component') : null;
const customAnimatedImage = document.querySelector('.static-initial-background img');

if (!customHeroBanner || !customHeroBackground) {
  console.warn('Hero banner elements not found in the DOM');
}

function animateHeroBanner(){
  if(!customHeroBanner) return;
  if(!customHeroBanner.classList.contains('animated')){
    customHeroBanner.classList.add('animated');
  }
}

history.scrollRestoration = 'manual';

window.addEventListener('touchstart', animateHeroBanner, { once: true });
window.addEventListener('mousewheel', animateHeroBanner, { once: true });
window.addEventListener('click', animateHeroBanner, { once: true });

window.addEventListener('DOMContentLoaded',()=>{
  setTimeout(animateHeroBanner,800)
})

if (customHeroBackground && customHeroBanner) {
  customHeroBackground.addEventListener('transitionend', (e) => {
    customHeroBanner.classList.add('auto');
    if (customAnimatedImage) customAnimatedImage.classList.add('hidden');
    if (customSlider && customSlider.carousel) customSlider.carousel.options = { drag: true };
  });
}
